import React from "react";
import {ParentRouteModel} from "../../models/parent-route.model";
import {IAgencyRoutes} from "./agency.routes.interface";
import {ChildRouteModel} from "../../models/child-route.model";
import {IServiceFactory} from "../../../service-factory.interface";
import {AgencyBookingSearchPage} from "../../../../pages/agency/booking-search/agency-booking-search.page";
import {RouteBaseModel} from "../../models/route-base.model";
import {AgencyProfilePage} from "../../../../pages/agency/profile/agency-profile.page";

export class AgencyRoutes extends ParentRouteModel implements IAgencyRoutes {
    constructor(services: IServiceFactory) {
        super('/agency', services);
    }

    bookingSearch = new ChildRouteModel('/booking-search', this,() => <AgencyBookingSearchPage/>);
    profile = new ChildRouteModel('/profile', this,() => <AgencyProfilePage/>);

    protected _getDefaultChildRoute(): RouteBaseModel | null {
        return null;
    }
}